import { withStyles } from '@material-ui/core';

import Image from './component';
import styles from './styles';

export default withStyles(styles)(Image);
